/* eslint-disable */
import axios from 'ggApp/utils/requests';


export function getCountries() {
  return (dispatch, getState) => dispatch({
    type: 'GET_COUNTRIES',
    promise: axios.get(`/countries`)
      .then(res => res.data.countries),
  })
}
